import React from 'react';
import { Link } from 'react-router-dom';
import ProjectArtwork from './projectArtwork';
import './projectCard.css';

export default function ProjectCard({ project, active, onHover, onFocus, onBlur, onSelect }) {
  return (
    <article
      className={`project-card project-card--${project.theme}${active ? ' is-active' : ''}`}
      onPointerEnter={(event) => {
        if (event.pointerType === 'mouse') onHover?.(project.id);
      }}
      onFocus={() => onFocus?.(project.id)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) onBlur?.();
      }}
    >
      <div className="project-card__topline" aria-hidden="true">
        <span className="project-card__number">00-{project.number.replace(/^0/, '')}</span>
        <span className="project-card__eyebrow">SELECTED<br />PROJECT</span>
      </div>
      <div className="project-card__visual"><ProjectArtwork project={project} /></div>
      <h3 className="project-card__title">
        {project.lines.map((line) => <span key={line}>{line}</span>)}
      </h3>
      <p className="project-card__description">{project.description}</p>
      <span className="project-card__spine" aria-hidden="true">{project.title}</span>
      {project.caseStudy ? <Link className="project-card__control" to={project.caseStudy} aria-label={`View ${project.title} case study`}><span className="project-card__arrow" aria-hidden="true">↗︎</span></Link> : project.href ? (
        <a className="project-card__control" href={project.href} aria-label={`View ${project.title}`}>
          <span className="project-card__arrow" aria-hidden="true">↗︎</span>
        </a>
      ) : (
        <button className="project-card__control" type="button"
          aria-label={`Expand ${project.title}`} aria-pressed={active}
          onClick={() => onSelect?.(project.id)}>
          <span className="project-card__arrow" aria-hidden="true">↗︎</span>
        </button>
      )}
    </article>
  );
}
